import { makeStyles } from "@mui/styles";
export default makeStyles(()=>({
    
        authContainer:{
            color:"red"
        },
        form:{
            margin:"10px"
        }
    
}));